import { Logo } from '../timeclock/Logo';
import { Button } from '../ui/button';
import { ConnectionIndicator } from '../timeclock/ConnectionIndicator';
import { ArrowLeft, LogOut, AlertTriangle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { resetConfiguration } from '@/services';
import { getPointeuseShowSessions } from '@/services/config.services';
import { useLateSessions } from '@/hooks/useSessions';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";




export const Header = () => {
    const location = useLocation();
    const isHomePage = location.pathname === "/home";
    const isPointeusePage = location.pathname === "/pointeuse";

    const { data: lateSessions = [] } = useLateSessions();
    const lateCount = lateSessions.length;
    const showLateOnClock =
      isPointeusePage && lateCount > 0;
    const canOpenSessionsList = getPointeuseShowSessions();

    const handleLogout = () => {
      resetConfiguration();
      window.location.href = "/";
    };
    return (
        <header className="shrink-0 bg-card border-b border-border z-10 grid grid-cols-[1fr_auto_1fr] items-center gap-2 px-4 py-2.5">
          <div className="justify-self-start flex items-center min-w-0">
                {isHomePage ? (
                    <AlertDialog>
                      <AlertDialogTrigger asChild>
                        <Button
                          variant="outline"
                          size="sm"
                          className="flex items-center px-3 py-1.5 rounded-full text-sm font-medium text-primary gap-2 shadow-lg p-2 bg-white/70 hover:bg-white border-white/70"
                        >
                          <LogOut className="h-4 w-4" />
                        </Button>
                      </AlertDialogTrigger>
                      <AlertDialogContent>
                        <AlertDialogHeader>
                          <AlertDialogTitle>Confirmer la deconnexion</AlertDialogTitle>
                          <AlertDialogDescription>
                            Voulez-vous vraiment vous deconnecter de la pointeuse ?
                          </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                          <AlertDialogCancel>Annuler</AlertDialogCancel>
                          <AlertDialogAction onClick={handleLogout}>
                            Se deconnecter
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialog>
                ) : (
                    <Link to="/home">
                        <Button
                            variant="outline"
                            type="button"
                            className="gap-1.5 rounded-full border-primary/30 bg-white px-3 py-1.5 text-sm font-medium text-primary shadow-sm transition-shadow hover:bg-primary/5 hover:shadow-md"
                            aria-label="Retour à l’accueil"
                        >
                            <ArrowLeft className="h-4 w-4 shrink-0" />
                            Retour
                        </Button>
                    </Link>
                )}
            </div>

            <div className="justify-self-center flex items-center justify-center min-w-0">
                <Logo />
            </div>
            <div className="justify-self-end flex items-center justify-end gap-2 min-h-10 min-w-0">
                {showLateOnClock ? (
                  canOpenSessionsList ? (
                    <Link
                      to="/sessions"
                      className="flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-2.5 py-1 text-xs font-semibold text-orange-800 shadow-sm hover:bg-orange-100 min-w-0 max-w-[min(100%,14rem)]"
                      title="Voir les pointages à clôturer"
                    >
                      <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-orange-600" aria-hidden />
                      <span className="min-w-[1.125rem] rounded-full bg-orange-500 px-1.5 py-0 text-center text-[10px] text-white">
                        {lateCount}
                      </span>
                      <span className="hidden min-[400px]:inline truncate">à dépointer</span>
                    </Link>
                  ) : (
                    <span
                      className="flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-2.5 py-1 text-xs font-semibold text-orange-800"
                      title="Des employés devraient dépointer. Activez l'affichage des pointages dans les paramètres pour voir le détail."
                    >
                      <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-orange-600" aria-hidden />
                      <span className="truncate">{lateCount} sans dép.</span>
                    </span>
                  )
                ) : null}
                <ConnectionIndicator />
            </div>
      </header>
    );
};